import { VALIDATOR_STRING_REQUIRED } from "newApp/constants/validation/validators";
import * as yup from "yup";

export default yup.object().shape({
  categoryId: VALIDATOR_STRING_REQUIRED,
});
